import type { MessagesState, MutationClass } from '../../../models'

export class SetLocaleMutation implements MutationClass {
  static execute(this: void, state: MessagesState, locale: string): void {
    state.locale = locale
  }
}
